import React from 'react';
import './RecapTierBanner.css';

/**
 * Recap tier banner — the audience label that makes the three tiers impossible
 * to confuse (design Q2; colour alone already failed). Icon + "Recap · <tier>"
 * title + a who-line spelling out exactly who reads it.
 *
 * The teacher-only tier wears the SAME privacy grammar as a captured Song Note:
 * eye-slash, muted, dashed border. That repetition is deliberate — "same lock
 * as a captured Song Note" is the who-line, and the visual echo teaches it.
 *
 * `unlinked` — the lesson has no student. On the two FAMILY-VISIBLE tiers the
 * who-line then states something false ("Cillian + parents read this") about a
 * recap that is saved with `studentId: null` and rejected by the customer read
 * rule, so it is REPLACED rather than supplemented: a warning under a promise
 * still reads as a promise. The route out names the control that actually
 * opens the linking step (pass 3 A5): the lesson name in the top bar opens
 * the Student drawer, where "Link a student" lives; the old copy pointed at a
 * ••• menu this page no longer has. The teachers-only tier is untouched, because its
 * audience is unaffected by linking — it was never going to the family.
 */
const RecapTierBanner = ({ tier, studentName = '', parentName = '', unlinked = false }) => {
	const stranded = unlinked && !tier.privateTier;

	return (
		<div
			className={`ld-tierbanner ld-tierbanner--${tier.hue}${tier.privateTier ? ' is-private' : ''}${
				stranded ? ' is-stranded' : ''
			}`}>
			<div className="ld-tierbanner__head">
				<i className={`fa-sharp fa-solid ${tier.icon}`} aria-hidden="true" />
				<span className="ld-tierbanner__title">{tier.title}</span>
			</div>
			{stranded ? (
				<p className="ld-tierbanner__who ld-tierbanner__who--stranded">
					<i className="fa-sharp fa-solid fa-link-slash" aria-hidden="true" />
					No student linked, so nobody in the family can read this recap. Tap the lesson name
					in the bar above to find a student.
				</p>
			) : (
				<p className="ld-tierbanner__who">{tier.whoLine(studentName, parentName)}</p>
			)}
		</div>
	);
};

export default RecapTierBanner;
